import React, {Component} from 'react';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';
import MakeHash from 'make-hash';
import EditForm from 'components/forms/edit-form';
import messages from './messages';

class RiderProfile extends Component {
  constructor(props) {
    super(props);

    const { intl } = props;

    this.state = {
      'fields': [
        {
          'label': intl.formatMessage(messages.name_label),
          'value': 'Staniel Road',
          'type': 'text',
          'name': 'name',
          'error': intl.formatMessage(messages.name_error)
        },
        {
          'label': intl.formatMessage(messages.bike_type_label),
          'name': 'bikeType',
          'value': 'Road',
          'options': [
            intl.formatMessage(messages.bike_type_road_label),
            intl.formatMessage(messages.bike_type_mountain_label),
            intl.formatMessage(messages.bike_type_city_label)
          ],
          'type': 'select'
        },
        {
          'label': intl.formatMessage(messages.position_label),
          'name': 'position',
          'value': 'Medium',
          'options': [
            intl.formatMessage(messages.position_low_label),
            intl.formatMessage(messages.position_medium_label),
            intl.formatMessage(messages.position_high_label)
          ],
          'type': 'select'
        },
        {
          'label': intl.formatMessage(messages.ride_frequency_label),
          'name': 'frequency',
          'value': '3 Times per week',
          'options': [
            intl.formatMessage(messages.ride_frequency_once_month_label),
            intl.formatMessage(messages.ride_frequency_once_week_label),
            intl.formatMessage(messages.ride_frequency_three_week_label),
            intl.formatMessage(messages.ride_frequency_six_week_label)
          ],
          'type': 'select'
        },
        {
          'label': intl.formatMessage(messages.ride_duration_label),
          'name': 'duration',
          'value': '30-60 minutes',
          'options': [
            intl.formatMessage(messages.ride_duration_short_label),
            intl.formatMessage(messages.ride_duration_medium_label),
            intl.formatMessage(messages.ride_duration_long_label),
            intl.formatMessage(messages.ride_duration_extended_label)
          ],
          'type': 'select'
        }
      ]
    };

    this.setUpHandlers();
  }

  /**
   * Binds any handlers to the correct context
   *
   * @method  setUpHandlers
   */
  setUpHandlers() {
    this.onFieldUpdate = this.handleFieldUpdate.bind(this);
  }

  handleFieldUpdate(fields) {
    // this.save().then ...
    this.updateFields();
  }

  /**
   * TODO: Return a promise after POST
   */
  save() {

  }

  /**
   * TODO: Update the fields state with confirmed data
   * after API success
   */
  updateFields(fields) {
    // this.setState({
    //   'fields':
    // });
  }

  render() {
    return (
      <EditForm
        fields={this.state.fields}
        isDeletable
        iconType="road"
        iconSize="full"
        onSave={this.onFieldUpdate}
        ref={(form) => {this.form = form}}
      />
    );
  }
}

export default injectIntl(RiderProfile);



// WEBPACK FOOTER //
// ./src/client/pages/profile/_rider-profile.jsx